import {ReactComponent as ScrollDownIcon} from '../assets/scroll_down.svg';

export function ScrollDownButton({onPress}){
    return (
        <div onClick={onPress} style={{padding: 16, cursor: "pointer"}}>
            <ScrollDownIcon/>
        </div>
    )
}